import { Component, Input } from '@angular/core';
import { NgClass } from "@angular/common";

@Component({
  selector: 'app-panel',
  standalone: true,
  imports: [
    NgClass
  ],
  templateUrl: './panel.component.html',
  styleUrl: './panel.component.scss'
})
export class PanelComponent {
  @Input() padding: string = 'md';
  @Input() margin: string = 'none';
  @Input() classNames: string = '';

  getClassNames() {
    const customClassNames = this.classNames.split(' ').filter(c => c); // Filter to remove empty strings

    const customClassesObject = customClassNames.reduce((acc, className) => {
      acc[className] = true;
      return acc;
    }, {} as Record<string, boolean>);

    return {
      ...customClassesObject,
      'panel': true,
      'padding-none': this.padding === 'none',
      'padding-xs': this.padding === 'xs',
      'padding-sm': this.padding === 'sm',
      'padding-md': this.padding === 'md',
      'padding-lg': this.padding === 'lg',
      'padding-xl': this.padding === 'xl',
      'padding-2xl': this.padding === '2xl',
      'margin-none': this.margin === 'none',
      'margin-xs': this.margin === 'xs',
      'margin-sm': this.margin === 'sm',
      'margin-md': this.margin === 'md',
      'margin-lg': this.margin === 'lg',
      'margin-xl': this.margin === 'xl',
      'margin-2xl': this.margin === '2xl',
    };
  }
}
